var map = {
	"./pmcariacica/icons/og/meta.jpg": 4813,
	"./pmci/icons/og/meta.jpg": 2878,
	"./pmvv/icons/og/meta.jpg": 4688,
	"./upcities/icons/og/meta.jpg": 8112
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 481;